import { useState, Fragment, useEffect } from "react";
import { Form, Input, Button, message } from "antd";
import { Redirect } from "react-router-dom";
import { getAccessTokenApi } from "../../api/auth";
import { CONST_ACCESS_TOKEN } from "../../utils/constants";
import * as SHARED from "../../utils/shared";
import { ExamLabel } from "../../components/commons";
import { login } from "../../api/participante";
import { getConfig } from "../../api/sistema";
import { Link } from "react-router-dom";

function ParticipanteLogin() {
  const [isLogging, setIsLogging] = useState(false);
  const [config, setConfig] = useState({
    activoSolicitaContrasenia: false
  });

  const [isLoading, setIsLoading] = useState(false);

  const fetchConfig = async () => {
    try {
      setIsLoading(true);
      const res = await getConfig();
      setConfig(res.payload);
    } catch (err) {
      setConfig({
        activoSolicitaContrasenia: false
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  if (getAccessTokenApi()) {
    return <Redirect to={{ pathname: SHARED.PATH_INSCRIPCION }} />;
  }

  const onFinish = (values) => {
    const { email, password } = values;
    sendDataToServer({ email, password });
  };

  const sendDataToServer = async (data) => {
    try {
      setIsLogging(true);
      const response = await login(data);
      setIsLogging(false);
      setTokensToLocalStorage(response);
      window.location.href = SHARED.PATH_INSCRIPCION;
    } catch (err) {
      setIsLogging(false);
      message.error(err.message);
    }
  };

  const setTokensToLocalStorage = ({ payload }) => {
    localStorage.setItem(CONST_ACCESS_TOKEN, payload.token);
  };

  return (
    <Fragment>
      <div className="max-w-xs mx-auto">
        <ExamLabel
          firstTitle={SHARED.TITLE_SISTEMA}
          secondTitle="Inicio de sesión"
          mainTitle={SHARED.PROCESO}
          style={{ background: "#D41D3D" }}
        />
      </div>

      <Form
        initialValues={{ remember: true }}
        onFinish={onFinish}
        className="max-w-xs mx-auto text-center"
        layout="vertical"
      >
        <Form.Item
          name="email"
          rules={[{ required: true, message: "El correo electrónico es necesario" }]}
        >
          <Input type="email" placeholder="Correo electrónico institucional" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: "La contraseña es necesaria"
            }
          ]}
        >
          <Input.Password placeholder="Contraseña" />
        </Form.Item>

        <div
          className={`bg-gray-100 border-t-4 mb-8 rounded-b text-teal-900 px-4 py-3 shadow-md`}
          role="alert"
        >
          <div className="text-center">
            <p className="text-sm">
              RECUERDE QUE DEBE UTILIZAR SU CORREO INSTITUCIONAL PARA INGRESAR AL SISTEMA
            </p>
            <p>
              <b>ejemplo: jperezh@unjbg.edu.pe</b>
            </p>
          </div>
          {/* <hr />
          <div className="text-center mt-2">
            <p className="text-sm">
              Nota: Se habilitará la inscripción de estudiantes cuando finalicen las matrículas del
              segundo semestre del 2023
            </p>
          </div> */}
        </div>

        <Form.Item>
          <Button type="primary" block loading={isLogging} htmlType="submit">
            Ingresar al sistema
          </Button>
        </Form.Item>

        {config.activoSolicitaContrasenia ? (
          <Link to={`/solicitar-contrasenia`}>
            <Button
              block
              type="secondary"
              loading={isLoading}
              disabled={!config.activoSolicitaContrasenia}
              className="bg-white-500 border-blue-500 text-blue-500 mb-3"
            >
              Quiero registrarme
            </Button>
          </Link>
        ) : (
          <p className="text-center italic mb-3 text-gray-500"> (Inscripciones cerradas)</p>
        )}

        <Link to="/reenviar-contrasenia">
          <Button className="mb-1" type="link" block>
            Olvidé mi contraseña
          </Button>
        </Link>
      </Form>
    </Fragment>
  );
}

export default ParticipanteLogin;
